import React from 'react';
import Icon from '../atoms/Icon';

function RankingsIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox='0 0 32 27'>
      <g fill='none' fillRule='evenodd' stroke='black' stroke-width='2.43902' stroke-miterlimit='10'>
        <path d='M30.7618 26.5673V9.49417'/>
        <path d='M25.8838 26.5673V11.9332'/>
        <path d='M21.0057 26.5673V14.3722'/>
        <path d='M16.1277 26.5673V16.8112'/>
        <path d='M11.2497 26.5673V19.2502'/>
        <path d='M6.37158 26.5673V21.6893'/>
        <path d='M1.49353 26.5673V24.1283'/>
      </g>

      <g fill='none' fillRule='evenodd' stroke='#F47321' stroke-width='2.43902' stroke-miterlimit='10'>
        <path d='M29.5423 2.17706L20.7618 7.66487L18.8106 5.5917L11.7374 10.8356L9.90815 9.00633L0.76181 16.3234'/>
        <path d='M23.9326 1.20148L29.5423 2.17709L28.2008 7.78684'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(RankingsIcon);
